module.exports = __webpack_public_path__ + "static/media/profile-placeholder.2df3f0cc.png";